/* @flow */

import type { CmsPage } from "shop-state/types";

import React, { useEffect } from "react";
import cn from "classnames";
import { useData } from "crustate/react";
import { CookieDialogue } from "@crossroads/ui-components";
import { useAnalytics } from "context/analytics";
import { CmsData } from "data";
import config from "config";

import styles from "./styles.scss";

type Props = {
  className?: string,
  country: { code: string },
  isVisible: boolean,
  setConsent: (value: string) => void,
  consent: string,
  consentRead: boolean,
  setToggleCookieDialogue: (value: boolean) => void,
};

const CookieConsent = ({
  className,
  country,
  isVisible,
  setConsent,
  consent,
  consentRead,
  setToggleCookieDialogue,
}: Props): React$Node => {
  const privacyData = useData(CmsData);
  const privacyContent: CmsPage | any = privacyData.data !== null ? privacyData.data : null;
  const {
    grantConsentNecessary,
    grantConsentStatistical,
    grantConsentMarketing,
    denyConsentStatistical,
    denyConsentMarketing,
  } = useAnalytics();

  useEffect(() => {
    if (consentRead && consent !== "initial") {
      if (consent === "accepted" || consent === "declined") {
        setConsent("initial");
        return;
      }

      const consentJson = JSON.parse(consent);

      if (consentJson.necessary) {
        grantConsentNecessary();
      }

      if (consentJson.statistical) {
        grantConsentStatistical();
      }
      else {
        denyConsentStatistical();
      }

      if (consentJson.marketing) {
        grantConsentMarketing();
      }
      else {
        denyConsentMarketing();
      }
    }

    if (consent === "initial") {
      setToggleCookieDialogue(true);
    }
  }, [consentRead, consent]);

  return (
    <div
      className={cn(
        styles.block,
        { [styles.visible]: isVisible },
        className
      )}
    >
      <CookieDialogue
        country={country}
        content={privacyContent}
        isVisible={isVisible}
        config={config}
        consent={consent}
        setConsent={setConsent}
        setToggleCookieDialogue={setToggleCookieDialogue}
      />
    </div>
  );
};

export default CookieConsent;
